import React, { MouseEventHandler, ReactNode } from 'react';

interface Props {
  className?: string;
  type: 'submit' | 'reset' | 'button';
  component: string;
  disabled?: boolean;
  form?: string;
  onClick?: MouseEventHandler;
  children: ReactNode;
  label?: string;
}

export const MainButton = ({
  className = '',
  type = 'button',
  form = '',
  children,
  onClick,
  component = '',
  disabled,
  label = '',
}: Props) => {
  if (component === 'button') {
    return (
      <button
        className={`main-button ${className}`}
        // eslint-disable-next-line react/button-has-type
        type={type}
        form={form}
        disabled={disabled}
        onClick={onClick}
        tabIndex={0}
        aria-label={label}
      >
        <span className="button-font-small">{children}</span>
      </button>
    );
  }

  return (
    <span className={`main-button ${className} ${disabled ? 'disabled' : ''}`} onClick={onClick}>
      <span className="button-font-small">{children}</span>
    </span>
  );
};
